export default "__VITE_ASSET__DwoOYrhI__"